<content *ngIf="data">
    <section class="entry-inline-framed" *ngIf="(!showPais && desPais) || (!showDenominacion && desDenominacion) || (!showEtiquetador && desEtiquetador)">
        <label *ngIf="!showPais && desPais">{{'centralEstadisticas.pais' | translate}} {{desPais}} </label>
        <label *ngIf="!showDenominacion && desDenominacion">{{'centralEstadisticas.denominacion' | translate}} {{desDenominacion}}</label>
        <label *ngIf="!showEtiquetador && desEtiquetador">{{'centralEstadisticas.etiquetador' | translate}} {{desEtiquetador}}</label>
    </section>
    <table>
        <thead>
            <tr>
                <th class="string" *ngIf="showPais">{{'global.pais' | translate}}</th>
                <th class="string" *ngIf="showDenominacion">{{'centralEstadisticas.grid.denominacion' | translate}}</th>
                <th class="string" *ngIf="showCampanya">{{'centralEstadisticas.grid.campanya' | translate}}</th>
                <th class="string" *ngIf="showEtiquetador">{{'centralEstadisticas.grid.etiquetador' | translate}}</th>
                <th class="string">{{'centralEstadisticas.etiquetado.designadosKg' | translate}}</th>
                <th class="string">{{'global.confeccionadoKg' | translate}}</th>
            </tr>
        </thead>
        <tbody *ngFor="let row of data; let i = index">
            <tr *ngIf="i < lastItemList && i >= firstItemList">
                <td class="string" *ngIf="showPais">{{row.desPais}}</td>
                <td class="string" *ngIf="showDenominacion">{{row.desDenominacion}}</td>
                <td class="string" *ngIf="showCampanya">{{row.anyo}}</td>
                <td class="string" *ngIf="showEtiquetador">{{row.desEtiquetador}}</td>
                <td class="string">{{row.kilosDesignados | number : '1.2-2': defaultLanguage}}</td>
                <td class="string">{{row.kilosExpedicion | number : '1.2-2': defaultLanguage}}</td>
            </tr>
        </tbody>
        <tfoot *ngIf="!data || (data && data.length < 1)">
            <tr>
                <td colspan="4">
                    {{'global.noContent' | translate}}
                </td>
            </tr>
        </tfoot>
    </table>
    <app-paginator
        *ngIf="(data && data.length > 0)"
        [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
        [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
</content>
<footer *ngIf="data" class="button-bar-right">
    <button (click)="close()">{{'global.aceptar' | translate}}</button>
</footer>
